import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export function getGroupRoles() {
  return request(`${ROOT_SERVER_URL}/api/group-roles`);
}
